import { connect } from 'react-redux';

import {
  GET_PLACE_DETAIL,
  EDIT_CANCEL_POLICY,
  CLEAR_PLACE_DETAIL,
  CLEAR_LIST_ROOM_OF_PLACE,
} from 'store/place/actionTypes';

import CancellationPolicy from './CancellationPolicy';

const mapStateToProps = (state) => ({
  isLoadingGetPlaceDetail: state.Place.isLoadingGetPlaceDetail,
  isLoadingEditCancelPolicy: state.Place.isLoadingEditCancelPolicy,

  placeDetail: state.Place.placeDetail,
  setting: state.Setting.setting,
});

const mapDispatchToProps = {
  actionGetPlaceDetail: (payload) => ({
    type: GET_PLACE_DETAIL,
    payload,
  }),

  actionClearPlaceDetail: () => ({
    type: CLEAR_PLACE_DETAIL,
  }),

  actionClearListRoomsOfPlace: () => ({
    type: CLEAR_LIST_ROOM_OF_PLACE,
  }),

  actionEditCancelPolicy: (payload) => ({
    type: EDIT_CANCEL_POLICY,
    payload,
  }),
};

export default connect(mapStateToProps, mapDispatchToProps)(CancellationPolicy);
